import classNames from "classnames";
import { Button, ButtonVariations } from "./button";

export const ApprovalButtonSet = ({
  onReject,
  onAccept,
  onClear,
  acceptText = "Accept",
  rejectText = "Decline",
  acceptVariant = "primary-dark",
  rejectVariant = "plain-2",
  className = "",
  disableActions = false,
  acceptLoading = false,
  rejectLoading = false,
}: {
  onReject: () => void;
  onAccept: () => void;
  onClear: () => void;
  acceptText?: string;
  rejectText?: string;
  acceptVariant?: ButtonVariations;
  rejectVariant?: ButtonVariations;
  className?: string;
  disableActions?: boolean;
  acceptLoading?: boolean;
  rejectLoading?: boolean;
}) => {
  return (
    <div
      className={classNames(
        "flex w-fit justify-between items-center gap-2",
        className
      )}
    >
      <Button
        type="button"
        onClick={() => {
          onClear();
        }}
        text={"Clear"}
        size="small"
        className="!px-4 whitespace-nowrap !w-fit !rounded-full"
        variation={"secondary-dark"}
        disabled={disableActions}
        loading={rejectLoading}
      />

      <Button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();

          onReject();
        }}
        text={rejectText}
        size="small"
        className="!px-4 whitespace-nowrap !w-fit !rounded-full ml-auto"
        variation={rejectVariant}
        disabled={disableActions}
        loading={rejectLoading}
      />

      <Button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();

          onAccept();
        }}
        text={acceptText}
        size="small"
        className="!px-4 whitespace-nowrap !w-fit !rounded-full"
        variation={acceptVariant}
        disabled={disableActions}
        loading={acceptLoading}
      />
    </div>
  );
};
